export default __webpack_public_path__ + "static/media/banner-1.f971809f.PNG";